import { Button } from "antd";
import { Drawer, Modal, Tooltip } from "flowbite-react";
import React, { useEffect, useState, useRef } from "react";
import TextEditor from "./TextEditor";
import { useNavigate } from "react-router-dom";
import axios, { all } from "axios";
import Loader from "./Loader";
import SuccessModal from "./SuccessModal";
import FailureModal from "./FailureModal";
import { toast } from "react-toastify";
import { clog } from "../lib/utils";

const EditableTable = ({
  knowledgeBaseRows,
  knowledgeBaseRowsData,
  getKnowledgeIdData,
  loadingList,
  lastElementRef,
  isOwner,
}) => {
  const [knowledgeBaseRowsCopied, setknowledgeBaseRowsCopied] = useState([]);
  const [data, setData] = useState([[]]);
  const [headerData, setheaderData] = useState([]);
  const [rowsData, setrowsData] = useState([]);
  // first index is header
  // next  index is data means each row
  const [closeOpen, setcloseOpen] = useState(false);
  const [editingCell, setEditingCell] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCols, setSelectedCols] = useState([]);
  const [newColumnsList, setnewColumnsList] = useState([]);
  const [stringOutput, setstringOutput] = useState("");
  const [textContent, settextContent] = useState("");
  const [editSave, seteditSave] = useState(false);
  const [selectedCell, setselectedCell] = useState({
    rowIndex: null,
    colIndex: null,
  });
  const [renameClicked, setrenameClicked] = useState(false);
  const [addColumnClicked, setaddColumnClicked] = useState(false);
  const [addName, setaddName] = useState("");
  const [createUrls, setcreateUrls] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const notify = (message, type) =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });
  // Add these state variables with your other useState declarations
  const [urls, setUrls] = useState([
    {
      value: "",
      error: "",
    },
  ]); // Initialize with one empty URL field

  // Add these functions with your other function declarations
  const handleUrlChange = (index, value) => {
    const newUrls = [...urls];
    // const urlPattern =
    //   /^(https?:\/\/)?(www\.)?[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z]{2,6}(\/.*)?$/;
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    if (!urlPattern.test(value)) {
      newUrls[index] = {
        value,
        error: "Invalid URL",
      };
    } else {
      newUrls[index] = {
        value,
        error: "",
      };
    }
    setUrls(newUrls);
  };
  clog(urls, "urls");
  const [savingUrls, setsavingUrls] = useState(false);
  const handleSaveUrls = async () => {
    if (!isOwner) {
      setsuccessFailureMessage("Only workspace owner can add URLs");
      setopenFailureModal("dismissible");
      return;
    }
    if (urls?.length === 0) {
      return;
    }
    // let allUrls = urls.map((url) => url?.value?.trim());
    let allUrls = [];
    // let knowledgeBaseRowsData = knowledgeBaseRows?.data;
    const normalizeUrl = (url) => url?.trim()?.replace(/\/$/, "");
    for (let i = 0; i < knowledgeBaseRowsData.length; i++) {
      const element = knowledgeBaseRowsData[i];
      let content_url = element?.content_url || "";
      if (content_url) {
        allUrls.push(normalizeUrl(content_url));
      }
    }
    const checkUrlInPrevIndex = (url, index) => {
      for (let i = 0; i < index; i++) {
        if (
          urls[i]?.value?.trim()?.length > 0 &&
          normalizeUrl(urls[i]?.value) === normalizeUrl(url)
        ) {
          return true;
        }
      }
      return false;
    };
    let newUrls = urls.map((item, index) => {
      if (
        allUrls.includes(normalizeUrl(item?.value)) ||
        checkUrlInPrevIndex(item?.value, index)
      ) {
        return {
          value: item?.value,
          error: "URL already exists",
        };
      } else {
        return item;
      }
    });
    clog(allUrls, "allUrls");
    // Filter out empty URLs
    const invalidUrls = newUrls?.filter(
      (url) => url?.value?.trim() === "" || url?.error
    );
    // clog("Invalid URLs:", invalidUrls);
    if (invalidUrls.length > 0) {
      clog("Invalid URLs:", invalidUrls);
      setUrls(newUrls);
      return;
    }
    try {
      setsavingUrls(true);
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/page/urls`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          workspace_id: JSON.parse(localStorage.getItem("login_data"))
            ?.resp_user?.workspace_id,
          knowledge_id: JSON.parse(
            localStorage.getItem("selected-knowledge-base")
          )?.knowledge_id,
          urls: urls?.map((item) => item?.value),
        },
      });
      if (!response.data.error) {
        notify(response?.data?.message, "success");
        setcreateUrls(false);
        setUrls([
          {
            value: "",
            error: "",
          },
        ]);
      } else {
        // Handle backend duplicate errors
        if (response.data.duplicateUrls && response.data.duplicateUrls.length > 0) {
          // Mark duplicate URLs with error messages
          const normalizedDuplicateUrls = response.data.duplicateUrls.map(url => normalizeUrl(url));
          const updatedUrls = urls.map((item, index) => {
            const normalizedValue = normalizeUrl(item?.value);
            if (normalizedDuplicateUrls.includes(normalizedValue)) {
              return {
                value: item?.value,
                error: "URL already exists",
              };
            }
            return item;
          });
          setUrls(updatedUrls);
          setsuccessFailureMessage(response?.data?.message || "Some URLs already exist. Please check and remove duplicates.");
          setopenFailureModal("dismissible");
        } else {
          setsuccessFailureMessage(response?.data?.message);
          setopenFailureModal("dismissible");
        }
      }
      setsavingUrls(false);
    } catch (error) {
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      } else if (error.response && error.response.data) {
        // Handle backend errors that come through error response
        const errorData = error.response.data;
        if (errorData.duplicateUrls && errorData.duplicateUrls.length > 0) {
          // Mark duplicate URLs with error messages
          const normalizedDuplicateUrls = errorData.duplicateUrls.map(url => normalizeUrl(url));
          const updatedUrls = urls.map((item, index) => {
            const normalizedValue = normalizeUrl(item?.value);
            if (normalizedDuplicateUrls.includes(normalizedValue)) {
              return {
                value: item?.value,
                error: "URL already exists",
              };
            }
            return item;
          });
          setUrls(updatedUrls);
          setsuccessFailureMessage(errorData?.message || "Some URLs already exist. Please check and remove duplicates.");
          setopenFailureModal("dismissible");
        } else {
          setsuccessFailureMessage(errorData?.message || "An error occurred while saving URLs.");
          setopenFailureModal("dismissible");
        }
      } else {
        setsuccessFailureMessage("An error occurred while saving URLs. Please try again.");
        setopenFailureModal("dismissible");
      }
      setsavingUrls(false);
    }
  };

  const handleAddUrl = () => {
    setUrls([...urls, { value: "", error: "" }]);
  };

  const handleRemoveUrl = (index) => {
    const newUrls = urls.filter((_, i) => i !== index);
    setUrls(newUrls);
  };
  const navigate = useNavigate();

  // Add a new row
  // const addRow = () => {
  //   setData((prevData) => [...prevData, Array(prevData[0].length).fill("")]);
  //   setrowsData((prevData) => [...prevData, Array(prevData[0].length).fill("")]);
  //   setEditingCell({ rowIndex: rowsData.length, colIndex: 0 });
  // };

  // Add a new column
  const addColumn = () => {
    if (!isOwner) {
      setsuccessFailureMessage("Only workspace owner can add columns");
      setopenFailureModal("dismissible");
      return;
    }
    // setData((prevData) => prevData.map((row) => [...row, ""]));

    callSaveApi("addColumn");
    // setEditingCell({ rowIndex: 0, colIndex: headerData.length });
  };

  // Delete selected rows
  const deleteSelectedRows = () => {
    setData((prevData) =>
      prevData.filter((_, index) => !selectedRows.includes(index))
    );
    setSelectedRows([]); // Clear selection after deletion
  };

  // Delete selected columns
  const deleteSelectedCols = () => {
    // setData((prevData) =>
    //   prevData.map((row) =>
    //     row.filter((_, index) => !selectedCols.includes(index))
    //   )
    // );
    // setSelectedCols([]); // Clear selection after deletion

    deleteSelectedColumn();
    setheaderData((prevData) =>
      prevData.filter((_, index) => index !== editingCell?.colIndex)
    );
    setrowsData((prevData) =>
      prevData.map((row) =>
        row.filter((_, index) => index !== editingCell?.colIndex)
      )
    );
  };

  // Handle cell click to enable editing
  const handleCellClick = (rowIndex, colIndex) => {
    if (!isOwner) {
      return; // Don't allow editing for non-owners
    }
    setEditingCell({ rowIndex, colIndex });
  };

  // Handle change in cell value
  const handleChange = (e, rowIndex, colIndex) => {
    const newValue = e.target.value;
    setData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][colIndex] = newValue;
      return newData;
    });
  };
  // clog(editingCell, "editingCell");
  const callSaveApi = async (from = "normal") => {
    // if (!isOwner) {
    //   setsuccessFailureMessage("Only workspace owner can edit knowledge base");
    //   setopenFailureModal("dismissible");
    //   setEditingCell(null);
    //   return;
    // }
    clog("coming here", editingCell);
    // clog(id);
    try {
      let data = {};
      if (from === "addColumn") {
        let newColumnName = addName;
        setheaderData((prevData) => [...prevData, newColumnName]);
        setrowsData((prevData) => prevData.map((row) => [...row, ""]));
        let column_no_global = 0;
        for (let i = 0; i < newColumnsList.length; i++) {
          let column_no = newColumnsList[i].column_no;
          column_no_global = Math.max(column_no_global, column_no);
        }
        setnewColumnsList((prevData) => [
          ...prevData,
          {
            head_name: newColumnName,
            column_no: column_no_global + 1,
            new: true,
          },
        ]);
        let knowledgebase_data = JSON.parse(
          localStorage.getItem("selected-knowledge-base")
        );
        // let knowledgeBaseRowsData = knowledgeBaseRows?.data;
        data["column_head"] = {
          head_name: newColumnName,
          column_no: column_no_global + 1,
        };
        data["knowledge_id"] = knowledgebase_data?.knowledge_id;
        data["id"] = knowledgeBaseRowsData[0].id;
      } else {
        if (!editingCell) return;
        let knowledgebase_data = JSON.parse(
          localStorage.getItem("selected-knowledge-base")
        );
        // let knowledgeBaseRowsData = knowledgeBaseRows?.data;
        let selectedRowData = knowledgeBaseRowsData[editingCell.rowIndex - 1];
        clog(selectedRowData, "selectedRowData");
        if (editingCell?.rowIndex !== 0) {
          data["id"] = selectedRowData.id;
        } else {
          data["id"] = knowledgeBaseRowsData[0].id;
        }
        let header = newColumnsList[editingCell.colIndex]?.head_name;
        let value =
          editingCell?.rowIndex !== 0
            ? rowsData[editingCell?.rowIndex - 1][editingCell?.colIndex]
            : "";
        clog(value, "value");
        if (editingCell?.rowIndex !== 0 && !value) {
          setEditingCell(null);
          return;
        }
        if (!newColumnsList[editingCell?.colIndex]?.new) {
          data[header] = value;
        } else {
          if (editingCell?.rowIndex !== 0) {
            let column_data = {};
            column_data["column_no"] =
              newColumnsList[editingCell?.colIndex].column_no;
            column_data["data_value"] = value;
            data["column_data"] = column_data;
          } else {
            let column_head = {};
            column_head["column_no"] =
              newColumnsList[editingCell?.colIndex].column_no;
            column_head["head_name"] = header;
            data["column_head"] = column_head;
          }
        }
        data["knowledge_id"] = knowledgebase_data?.knowledge_id;
        setheaderData((prevData) =>
          prevData.map((item, index) =>
            index === editingCell?.colIndex
              ? newColumnsList[editingCell?.colIndex]?.head_name
              : item
          )
        );
        clog(data, "data");
        setEditingCell(null);
        setaddColumnClicked(false);
        setrenameClicked(false);
        setaddName("");
      }
      setaddColumnClicked(false);
      setaddName("");
      // return;
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/knowledgebase_update`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        // clog(response.data);
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  // clog(addColumnClicked, "addColumnClicked");
  const deleteSelectedColumn = async () => {
    if (!isOwner) {
      setsuccessFailureMessage("Only workspace owner can delete columns");
      setopenFailureModal("dismissible");
      return;
    }
    // clog(id);
    try {
      let knowledgebase_data = JSON.parse(
        localStorage.getItem("selected-knowledge-base")
      );
      // let knowledgeBaseRowsData = knowledgeBaseRows?.data;
      let data = {};
      data["knowledge_id"] = knowledgebase_data?.knowledge_id;
      let selectedColumn = editingCell?.colIndex;
      let column_no = newColumnsList[selectedColumn].column_no;
      data["column_no"] = column_no;
      // return;
      setnewColumnsList((prevData) =>
        prevData.filter((item) => item.column_no != column_no)
      );
      setSelectedCols([]); // Clear selection;
      setEditingCell(null);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/knowledgebase_columndelete`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        // clog(response.data);
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  clog(newColumnsList, "newColumnsList");

  // Handle blur event to stop editing
  const handleBlur = (from) => {
    callSaveApi(from);
  };

  // Handle row selection
  const handleRowSelection = (rowIndex) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(rowIndex)
        ? prevSelected.filter((i) => i !== rowIndex)
        : [...prevSelected, rowIndex]
    );
  };

  // Handle column selection
  const handleColSelection = (colIndex) => {
    setSelectedCols((prevSelected) =>
      prevSelected.includes(colIndex)
        ? prevSelected.filter((i) => i !== colIndex)
        : [...prevSelected, colIndex]
    );
  };
  const handleAddColumn = (colIndex) => {
    const updatedData = data.map((row) => {
      const newRow = [...row];
      newRow.splice(colIndex + 1, 0, ""); // Insert an empty cell to the right
      return newRow;
    });
    setData(updatedData); // Update the state
  };
  function capitalizeWords(input) {
    if (input === "content_url") {
      return "URL";
    }
    return input
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back with spaces
  }
  const checkDisplayCheckboxes = (colIndex) => {
    if (selectedCols.length > 0) {
      if (selectedCols.includes(colIndex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  clog(knowledgeBaseRows, "knowledgeBaseRowsData");
  // const getInitialData = () => {
  //   let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //   const header = Object.keys(knowledgeBaseRowsData[0]);
  //   let noNeedColumns = [
  //     "id",
  //     "workspace_id",
  //     "knowledge_id",
  //     "user_id",
  //     "doc_type",
  //     "status",
  //     "createdAt",
  //     "updatedAt",
  //     "custom_fields",
  //     "__v",
  //     "knowledgedata",
  //   ];
  //   let standardColumns = header.filter(
  //     (item) => !noNeedColumns.includes(item)
  //   );
  //   let newColumns = [...standardColumns];
  //   let knowledgehead = knowledgeBaseRows?.knowledgehead;
  //   for (let i = 0; i < knowledgehead.length; i++) {
  //     if (!newColumns.includes(knowledgehead[i].head_name)) {
  //       newColumns.push(knowledgehead[i].head_name);
  //     }
  //   }
  //   let newRows = knowledgeBaseRowsData.map((row, row_index) => {
  //     let newRow = [];
  //     standardColumns.forEach((item) => {
  //       newRow.push(row[item]);
  //     });
  //     for (let i = 0; i < knowledgehead.length; i++) {
  //       let knowledgedata = knowledgeBaseRowsData[row_index]?.knowledgedata;
  //       let knowledgedataIndex = knowledgedata.findIndex(
  //         (item) => item.column_no === knowledgehead[i].column_no
  //       );
  //       if (knowledgedataIndex !== -1) {
  //         newRow.push(knowledgedata[knowledgedataIndex].data_value);
  //       } else {
  //         newRow.push("");
  //       }
  //     }

  //     return newRow;
  //   });
  //   clog(newRows, "newRows");
  //   setnewColumnsList(knowledgehead);
  //   setheaderData(newColumns || []);
  //   setrowsData(newRows || []);
  //   setknowledgeBaseRowsCopied(knowledgeBaseRowsData);
  // };
  const getInitialData = () => {
    // let knowledgeBaseRowsData = knowledgeBaseRows?.data;
    if (knowledgeBaseRowsData.length === 0) {
      return;
    }
    const header = Object.keys(knowledgeBaseRowsData[0] || "{}");
    let noNeedColumns = [
      "id",
      "workspace_id",
      "knowledge_id",
      "user_id",
      "doc_type",
      "status",
      "createdAt",
      "updatedAt",
      "custom_fields",
      "__v",
      "knowledgedata",
    ];
    let standardColumns = header.filter(
      (item) => !noNeedColumns.includes(item)
    );
    let newColumns = [...standardColumns];
    let knowledgehead = knowledgeBaseRows?.knowledgehead;
    for (let i = 0; i < knowledgehead.length; i++) {
      if (!newColumns.includes(knowledgehead[i].head_name)) {
        newColumns.push(knowledgehead[i].head_name);
      }
    }
    let newRows = knowledgeBaseRowsData.map((row, row_index) => {
      let newRow = [];
      standardColumns.forEach((item) => {
        newRow.push(row[item]);
      });
      for (let i = 0; i < knowledgehead.length; i++) {
        let knowledgedata = knowledgeBaseRowsData[row_index]?.knowledgedata;
        let knowledgedataIndex = knowledgedata.findIndex(
          (item) => item.column_no === knowledgehead[i].column_no
        );
        if (knowledgedataIndex !== -1) {
          newRow.push(knowledgedata[knowledgedataIndex].data_value);
        } else {
          newRow.push("");
        }
      }

      return newRow;
    });
    // clog(newRows, "newRows");
    // adding old header to new column list with new:false
    let newColumnList = [];
    for (let i = 0; i < standardColumns.length; i++) {
      newColumnList.push({
        head_name: standardColumns[i],
        column_no: 0,
        new: false,
      });
    }
    // adding new header to new column list with new:true
    for (let i = 0; i < knowledgehead.length; i++) {
      newColumnList.push({
        head_name: knowledgehead[i].head_name,
        column_no: knowledgehead[i].column_no,
        new: true,
      });
    }
    setnewColumnsList(newColumnList);
    setheaderData(newColumns || []);
    setrowsData(newRows || []);
    setknowledgeBaseRowsCopied(knowledgeBaseRowsData);
  };
  useEffect(() => {
    if (Object.keys(knowledgeBaseRows || {}).length === 0) return;
    getInitialData();
  }, [
    knowledgeBaseRows,
    // Object.keys(knowledgeBaseRows || {})?.length,
    // Object.keys(knowledgeBaseRows || {})?.data?.length,
  ]);
  // clog(data, "data");
  // clog(headerData, "headerData");
  // clog(rowsData, "rowsData");
  // Add a ref for the popup
  // clog(rowsData, "rowsData");
  const popupRef = useRef(null);
  const textAreaRef = useRef(null);
  const tableRef = useRef(null); // Ref for the entire table

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside the table
      if (tableRef.current && !tableRef.current.contains(event.target)) {
        clog("Clicked outside the editable table");
        setaddColumnClicked(false);
        if (editingCell?.rowIndex === 0) {
          setEditingCell(null);
          return;
        }
        callSaveApi("normal");
      }
    };

    // Attach the event listener for clicks
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [tableRef, editingCell?.rowIndex, editingCell?.colIndex]);
  useEffect(() => {
    if (editingCell?.rowIndex === 0) return;
    if (
      selectedCell?.rowIndex !== editingCell?.rowIndex ||
      selectedCell?.colIndex !== editingCell?.colIndex
    ) {
      callSaveApi("normal");
    }
  }, [
    selectedCell?.rowIndex,
    selectedCell?.colIndex,
    editingCell?.rowIndex,
    editingCell?.colIndex,
  ]);

  return (
    <>
      <div className="flex items-center justify-between">
        <h4 className="text-[24px] font-[600] pb-4">
          <span
            onClick={() => {
              navigate("/knowledge");
            }}
            className="cursor-pointer"
          >
            Knowledge Base
          </span>{" "}
          {">"}{" "}
          {
            JSON.parse(localStorage.getItem("selected-knowledge-base"))
              ?.knowledge_name
          }
        </h4>
        {isOwner ? (
          <button
            type="button"
            className="flex justify-center items-center py-2 w-[280px] me-8 px-[80px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75"
            onClick={() => {
              setcreateUrls(true);
              setUrls([
                {
                  value: "",
                  error: "",
                },
              ]); // Initialize with one empty URL field
            }}
          >
            <svg className="icon me-2 text-[14px]">
              <use href="#icon_plus"></use>
            </svg>
            <span className=" text-[18px]">Add URLs</span>
          </button>
        ) : (
          <Tooltip
            content="This action can only be done by workspace owner"
            placement="bottom"
          >
            <button
              type="button"
              className="flex justify-center items-center py-2 w-[280px] me-8 px-[80px] rounded-[20px] font-semibold bg-gray-200 text-gray-500 cursor-not-allowed"
              disabled
            >
              <svg className="icon me-2 text-[14px]">
                <use href="#icon_plus"></use>
              </svg>
              <span className=" text-[18px]">Add URLs</span>
            </button>
          </Tooltip>
        )}
      </div>
      {/* <TableComponent /> */}

      {/* {!loadingList && ( */}
      <div className="editable-table-container">
        {/* <div className="table-actions flex items-center justify-between w-full">
          <div className="">
            {" "}
            <button onClick={addRow}>Add Row</button>
            <button
              className=" py-2 me-8 w-[200px]  px-[10px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75"
              onClick={addColumn}
            >
              Add Column
            </button>
            <button onClick={deleteSelectedRows}>Delete Selected Rows</button>
            {selectedCols.length > 0 && (
              <button
                className=" py-2 me-8 px-[10px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75"
                onClick={deleteSelectedCols}
              >
                Delete Selected Column
              </button>
            )}
          </div>
        </div> */}
        <div className="editable-table max-h-[calc(100vh-100px)] overflow-y-auto" ref={tableRef}>
          <table>
            <thead className="sticky top-0 z-20 bg-white">
              <tr>
                <th
                  style={{
                    resize: "none",
                  }}
                >
                  <div className="header-content">S.No</div>
                </th>
                {headerData.map((header, colIndex) => (
                  <th
                    key={colIndex}
                    onDoubleClick={(e) => {
                      if (!isOwner) {
                        return;
                      }
                      if (newColumnsList[colIndex]?.new) {
                        setrenameClicked(false);
                        setnewColumnsList((prevData) =>
                          prevData.map((item, index) =>
                            index === colIndex
                              ? {
                                  ...item,
                                  head_name: headerData[colIndex],
                                }
                              : item
                          )
                        );
                        setaddColumnClicked(false);
                        handleCellClick(0, colIndex);
                      }
                    }}
                    title={
                      !isOwner && newColumnsList[colIndex]?.new
                        ? "This action can only be done by workspace owner"
                        : ""
                    }
                    style={{
                      position: "relative",
                      resize: "none",
                      overflow: "visible",
                      minWidth: "198px",
                      backgroundColor:
                        editingCell?.rowIndex === 0 &&
                        editingCell?.colIndex === colIndex &&
                        "#097ba9",
                      color:
                        editingCell?.rowIndex === 0 &&
                        editingCell?.colIndex === colIndex &&
                        "#fff",
                    }}
                    className="select-none"
                  >
                    {newColumnsList[colIndex]?.new &&
                      editingCell?.rowIndex === 0 &&
                      editingCell?.colIndex === colIndex && (
                        <div
                          className="w-[178px] rounded-[10px] p-[10px] absolute bg-white"
                          style={{
                            boxShadow: "0px 3px 4px 0px #0000000f",
                            position: "absolute",
                            top: "55px",
                            left: "10px",
                            zIndex: "10",
                          }}
                        >
                          <ul>
                            {renameClicked && (
                              <li className="mb-2">
                                <>
                                  <input
                                    type="text"
                                    id="lname"
                                    name="lname"
                                    placeholder="Enter name"
                                    value={newColumnsList[colIndex]?.head_name}
                                    className="w-full border-0 focus:ring-0 text-black"
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();

                                      setnewColumnsList((prevData) =>
                                        prevData.map((item, index) =>
                                          index === colIndex
                                            ? {
                                                ...item,
                                                head_name: e.target.value,
                                              }
                                            : item
                                        )
                                      );
                                    }}
                                  />
                                  <hr />
                                  <button
                                    type="button"
                                    className="flex items-center w-full bg-[#097BA9] rounded-full text-[#fff] py-1 flex items-center justify-center hover:bg-[#085b7ced] duration-200 mt-2"
                                    onClick={() => {
                                      callSaveApi();
                                      setrenameClicked(false);
                                    }}
                                  >
                                    Update
                                  </button>
                                </>
                                <hr />
                              </li>
                            )}
                            {!renameClicked && (
                              <li className="mb-2">
                                {isOwner ? (
                                  <button
                                    type="button"
                                    className="flex items-center w-full text-black hover:text-[#097BA9]"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      setrenameClicked(true);
                                    }}
                                  >
                                    <svg className="icon me-2">
                                      <use href="#icon_edit"></use>
                                    </svg>
                                    Rename Column
                                  </button>
                                ) : (
                                  <Tooltip
                                    content="This action can only be done by workspace owner"
                                    placement="right"
                                  >
                                    <button
                                      type="button"
                                      className="flex items-center w-full text-gray-400 cursor-not-allowed"
                                      disabled
                                    >
                                      <svg className="icon me-2">
                                        <use href="#icon_edit"></use>
                                      </svg>
                                      Rename Column
                                    </button>
                                  </Tooltip>
                                )}
                              </li>
                            )}
                            <li>
                              {isOwner ? (
                                <button
                                  type="button"
                                  className="flex items-center w-full text-black hover:text-[#097BA9]"
                                  onClick={deleteSelectedCols}
                                >
                                  <svg className="icon me-2">
                                    <use href="#icon_delete_tbl"></use>
                                  </svg>
                                  Delete
                                </button>
                              ) : (
                                <Tooltip
                                  content="This action can only be done by workspace owner"
                                  placement="right"
                                >
                                  <button
                                    type="button"
                                    className="flex items-center w-full text-gray-400 cursor-not-allowed"
                                    disabled
                                  >
                                    <svg className="icon me-2">
                                      <use href="#icon_delete_tbl"></use>
                                    </svg>
                                    Delete
                                  </button>
                                </Tooltip>
                              )}
                            </li>
                          </ul>
                        </div>
                      )}

                    <div className="header-content">
                      {capitalizeWords(header)}
                    </div>
                  </th>
                ))}
                <th
                  style={{
                    position: "relative",
                    resize: "none",
                    overflow: "visible",
                    minWidth: "198px",
                    backgroundColor: addColumnClicked && "#097ba9",
                    color: addColumnClicked && "#fff",
                    cursor: !isOwner ? "not-allowed" : "pointer",
                  }}
                  className="select-none"
                  onClick={(e) => {
                    if (!isOwner) {
                      return;
                    }
                    setaddColumnClicked(true);
                    setEditingCell(null);
                  }}
                  title={
                    !isOwner
                      ? "This action can only be done by workspace owner"
                      : ""
                  }
                >
                  {addColumnClicked && isOwner && (
                    <div
                      className="w-[178px] rounded-[10px] p-[10px] absolute bg-white"
                      style={{
                        boxShadow: "0px 3px 4px 0px #0000000f",
                        position: "absolute",
                        top: "55px",
                        left: "10px",
                        zIndex: "10",
                      }}
                    >
                      <ul>
                        <li className="mb-2">
                          <>
                            <input
                              type="text"
                              id="lname"
                              name="lname"
                              placeholder="Enter name"
                              value={addName}
                              className="w-full border-0 focus:ring-0 text-black"
                              onChange={(e) => {
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                setaddName(e.target.value);
                              }}
                            />
                            <hr />
                            <button
                              type="button"
                              className="flex items-center w-full bg-[#097BA9] rounded-full text-[#fff] py-1 flex items-center justify-center hover:bg-[#085b7ced] duration-200 mt-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                setaddColumnClicked(false);
                                addColumn();
                              }}
                            >
                              + Add Column
                            </button>
                          </>
                          <hr />
                        </li>
                      </ul>
                    </div>
                  )}
                  <div className="header-content">+ Add Column</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rowsData.map((row, rowIndex) => (
                <tr
                  key={rowIndex + 1}
                  ref={
                    rowIndex === rowsData?.length - 1 ? lastElementRef : null
                  }
                >
                  {/* <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(rowIndex + 1)}
                    onChange={() => handleRowSelection(rowIndex + 1)}
                  />
                </td> */}
                  <td
                    style={{
                      resize: "none",
                    }}
                  >
                    {rowIndex + 1}
                  </td>
                  {row.map((cell, colIndex) => (
                    <td
                      className="abs-td relative "
                      key={colIndex}
                      onClick={(e) => {
                        if (!cell) {
                          e.stopPropagation();
                        }
                        setselectedCell({
                          rowIndex: rowIndex + 1,
                          colIndex,
                        });
                      }}
                      onDoubleClick={(e) => {
                        e.stopPropagation();
                        if (!isOwner) {
                          return;
                        }
                        if (
                          newColumnsList[colIndex]?.new ||
                          headerData[colIndex] === "content_title"
                        ) {
                          setEditingCell({
                            rowIndex: rowIndex + 1,
                            colIndex,
                          });
                        }
                        setselectedCell({
                          rowIndex: rowIndex + 1,
                          colIndex,
                        });
                      }}
                      title={
                        !isOwner &&
                        (newColumnsList[colIndex]?.new ||
                          headerData[colIndex] === "content_title")
                          ? "This action can only be done by workspace owner"
                          : ""
                      }
                      style={{
                        resize: "none",
                        position: "relative", // Ensure the td has position relative
                        overflow: "visible", // Make sure overflow is visible,
                        backgroundColor:
                          editingCell?.rowIndex === 0 &&
                          editingCell?.colIndex === colIndex &&
                          "#e9f2ff",
                        cursor:
                          !isOwner &&
                          (newColumnsList[colIndex]?.new ||
                            headerData[colIndex] === "content_title")
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      <div>
                        {editingCell?.rowIndex === rowIndex + 1 &&
                          editingCell?.colIndex === colIndex && (
                            <div
                              className="tbl-contentBox"
                              ref={popupRef}
                              style={{
                                position: "fixed", // Change from absolute to fixed
                                zIndex: 1000, // Higher z-index
                              }}
                            >
                              <div className="wrapper-box">
                                <div>
                                  <textarea
                                    ref={textAreaRef}
                                    style={{
                                      resize: "none",
                                      minWidth: "200px",
                                      minHeight: "100px",
                                    }}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      const newData = [...rowsData];
                                      newData[rowIndex][colIndex] = newValue;
                                      setrowsData(newData);
                                    }}
                                    value={rowsData[rowIndex][colIndex]}
                                    name=""
                                    id=""
                                    cols="28"
                                    rows="8"
                                  ></textarea>
                                </div>
                                <Button
                                  className="angle-expand"
                                  onClick={(e) => {
                                    // handleButtonClick(record);
                                    e.stopPropagation();
                                    setstringOutput(
                                      rowsData[rowIndex][colIndex]
                                    );
                                    setcloseOpen(true);
                                    setEditingCell(null);
                                  }}
                                >
                                  <svg className="icon">
                                    <use href="#icon_arrows-angle-expand"></use>
                                  </svg>
                                </Button>
                              </div>
                            </div>
                          )}
                      </div>
                      <div className="px-3 flex items-center justify-between content-container">
                        <div
                          style={{
                            height:
                              headerData[colIndex] === "contents"
                                ? "100px"
                                : "",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {headerData[colIndex] === "content_url" &&
                          /\.(pdf|docx|doc)$/i.test(cell)
                            ? // Extract and display only the file name
                              (() => {
                                const fileName = cell.split("/").pop();
                                // Match the timestamp pattern at the end (numbers and extension)
                                const withoutTimestampAndExt = fileName.replace(
                                  /-\d+\.[^.]+$/,
                                  ""
                                );
                                return withoutTimestampAndExt;
                              })()
                            : cell}
                        </div>
                        <div>
                          {/* colindex===contents */}
                          {headerData[colIndex] === "contents" && (
                            <Button
                              onClick={(e) => {
                                // handleButtonClick(record);
                                e.stopPropagation();
                                setstringOutput(cell);
                                setcloseOpen(true);
                              }}
                              className="editable-cell-button "
                              // style={{ marginLeft: "8px", flexShrink: 0 }} // Prevent button from shrinking
                            >
                              <svg className="icon">
                                <use href="#icon_arrows-angle-expand"></use>
                              </svg>
                            </Button>
                          )}
                          {/* colindex===TITLE */}
                          {headerData[colIndex] === "content_title" && (
                            <>
                              {isOwner ? (
                                <Button
                                  onClick={(e) => {
                                    setEditingCell({
                                      rowIndex: rowIndex + 1,
                                      colIndex,
                                    });
                                  }}
                                  // className="hover:bg-gray-100 p-2 rounded transition duration-200 mt-1"
                                  className="editable-cell-button "
                                >
                                  <svg className="icon">
                                    <use href="#icon_edit"></use>
                                  </svg>
                                </Button>
                              ) : (
                                <Tooltip
                                  content="This action can only be done by workspace owner"
                                  placement="top"
                                >
                                  <Button
                                    disabled
                                    className="editable-cell-button opacity-50 cursor-not-allowed"
                                  >
                                    <svg className="icon">
                                      <use href="#icon_edit"></use>
                                    </svg>
                                  </Button>
                                </Tooltip>
                              )}
                            </>
                          )}
                          {/* colindex===URL */}
                          {headerData[colIndex] === "content_url" &&
                            /\.(pdf|docx|doc)$/i.test(cell) && (
                              <Button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (cell) {
                                    // Create a temporary anchor element to trigger the download
                                    const link = document.createElement("a");
                                    link.href = cell; // Set the URL from the cell
                                    let fileName = cell.split("/").pop(); // Extract the file name from the URL
                                    if (fileName.includes(".pdf")) {
                                      link.target = "_blank"; // Open in a new tab for PDF files
                                    }
                                    link.download = cell.split("/").pop(); // Set the file name from the URL
                                    link.click(); // Trigger the download
                                  }
                                }}
                                // className="hover:bg-gray-100 p-2 rounded transition duration-200"
                                className="editable-cell-button "
                              >
                                <svg className="icon">
                                  <use href="#icon_download"></use>
                                </svg>
                              </Button>
                            )}
                        </div>
                      </div>
                    </td>
                  ))}
                  <td
                    style={{
                      pointerEvents: "none",
                      backgroundColor: addColumnClicked && "#e9f2ff",
                    }}
                  ></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* )} */}
      {loadingList && (
        // Skeleton layout that mirrors the editable table structure
        <div className="mt-6 space-y-3">
          {/* Header skeleton */}
          <div className="flex justify-between items-center mb-2">
            <div className="h-6 w-40 bg-gray-300 rounded skeleton-wave"></div>
            <div className="h-9 w-32 bg-gray-300 rounded-full skeleton-wave"></div>
          </div>
          {/* Table header skeleton */}
          <div className="w-full border border-[#DCDCDC] rounded-[20px] overflow-hidden bg-white">
            <div className="grid grid-cols-6 gap-2 px-4 py-3 border-b border-[#DCDCDC] bg-[#FAFBFC]">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="h-4 w-24 bg-gray-300 rounded skeleton-wave"></div>
              ))}
              <div className="h-4 w-10 bg-gray-300 rounded skeleton-wave justify-self-end"></div>
            </div>
            {/* Table body skeleton rows */}
            <div className="divide-y divide-[#F0F0F0]">
              {[...Array(5)].map((_, rowIndex) => (
                <div
                  key={rowIndex}
                  className="grid grid-cols-6 gap-2 px-4 py-3 items-center"
                >
                  <div className="h-4 w-32 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="h-4 w-24 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="h-4 w-24 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="h-4 w-20 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="h-4 w-20 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="flex justify-end">
                    <div className="h-8 w-8 rounded-full bg-gray-300 skeleton-wave"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <Drawer
        open={createUrls}
        onClose={() => {
          setcreateUrls(false);
        }}
        position="right"
        className={`p-0 w-[600px] notification-canvas`}
      >
        <Drawer.Header title="Add URLs" className="pt-3 border border-bottom" />
        <Drawer.Items>
          {urls.map((url, index) => (
            <div key={index} className="flex items-center gap-2 my-3 px-3">
              <div className="flex items-baseline">{index + 1}.</div>
              <div className="w-full">
                <input
                  type="text"
                  value={url?.value}
                  placeholder="https://www.abc.com"
                  onChange={(e) => handleUrlChange(index, e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 focus:outline-none focus:border-blue-500 shadow-md rounded-full bg-[#FFFFFF]"
                />
                {url?.error && (
                  <p className="text-red-500 pt-2">{url?.error}</p>
                )}
              </div>
              {urls.length > 1 && (
                <button
                  onClick={() => handleRemoveUrl(index)}
                  className="p-2 rounded"
                  title="Remove URL"
                >
                  <svg className="w-5 h-5 text-red-500 hover:text-red-600">
                    <use href="#icon_delete"></use>
                  </svg>
                </button>
              )}
            </div>
          ))}
          {/* Add URL button at the bottom */}
          <div className="flex justify-center items-center mt-2">
            <button
              onClick={handleAddUrl}
              // className="p-2 px-4 text-white bg-blue-500 rounded hover:bg-blue-600 flex items-center gap-2"
              className="mb-[40px] py-2  me-8 px-[40px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex justify-center items-center w-[200px]"
              title="Add URL"
            >
              <svg className="w-5 h-5 me-2">
                <use href="#icon_plus"></use>
              </svg>
              Add URL
            </button>
            <button
              onClick={handleSaveUrls}
              disabled={savingUrls}
              className="mb-[40px] py-2  me-8 px-[40px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex justify-center items-center w-[200px]"
            >
              {savingUrls ? <Loader /> : "Save URLs"}
            </button>{" "}
          </div>
          <div className="flex justify-center items-center mt-4"></div>
        </Drawer.Items>
      </Drawer>

      <Modal
        show={closeOpen}
        size="6xl"
        onClose={() => setcloseOpen(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="w-full">
            <TextEditor
              stringOutput={stringOutput}
              setstringOutput={setstringOutput}
              from="knowledgebase"
            />
          </div>
        </Modal.Body>
      </Modal>
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
    </>
  );
};

export default EditableTable;
